/**
 * Server-side event relay: relays trackAnalytics() calls to backend-core-v2's
 * /api/events/track, which forwards them to Stape (server-side GTM) so ad
 * blockers stripping the browser-side Segment/PostHog/GA calls don't cause
 * conversions to go unreported. See openspec/changes/server-side-event-tracking.
 */
import apiClient from "src/services/apiClient";

export interface TrackEventPage {
  url: string;
  referrer?: string;
}

export interface TrackEventPayload {
  event_id: string;
  event_name: string;
  occurred_at: string;
  anonymous_id?: string | null;
  user_id?: string | null;
  page: TrackEventPage;
  properties: Record<string, unknown>;
}

export interface TrackEventResponse {
  event_id: string;
}

export const trackEventServerSide = async (
  payload: TrackEventPayload
): Promise<TrackEventResponse> => {
  const { data } = await apiClient.post<TrackEventResponse>("/api/events/track", payload);
  return data;
};
